<template>
    <div v-if="data" class="sustainability-case">
        <headline :title="data.title"></headline>
        <div v-if="list.length" class="list">
            <div v-for="item in list" :key="item.id" @click="goDetail(item.id)" class="item  base-shadow">
                <img v-src="item.detail.banner" alt="" />
                <div class="box">
                    <div class="title">{{ item.detail.name }}</div>
                    <div>{{ item.detail.intro }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getDataHierarchy, getDataRows } from '@custouch/proxy-use'
import headline from './components/headline.vue'
import { Toast } from 'vant'
const { CMS } = window.env
export default {
    name: 'Case',
    props: ['hId'],
    components: { headline },
    data() {
        return {
            data: {},
            list: []
        }
    },
    async created() {
        const loadingToast = Toast.loading()
        const [ret, { data }] = await Promise.all([
            getDataHierarchy({ dataHierarchyId: this.hId }),
            getDataRows({
                dataHierarchyId: this.hId,
                dataTemplateId: CMS.template.susCase,
                index: 1,
                size: 100,
                orderBy: 'index',
                desc: false
            })
        ])
        this.data = ret.detail
        this.list = data
        loadingToast.clear()
    },
    methods: {
        goDetail(rId){
            this.$router.push({
                name: 'CaseDetail',
                params: {
                    hId: this.hId,
                    rId
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.sustainability-case {
    padding: @padding-lg 0;
    .list {
        .item {
            background: @white;
            border-radius: @border-radius-sm + @border-radius-md;
            width: 100%;
            margin-top: @padding-md;
            padding: 0.3rem;
            min-height: 15.6rem;
            font-size: @font-size-sm;
            color: @green;
            img {
                width: 100%;
                height: 9.25rem;
                object-fit: contain;
                border-radius: @border-radius-md;
            }
            .box {
                padding: @padding-sm @padding-sm / 2 0;
                .title {
                    font-weight: @font-weight-bold;
                    font-size: @font-size-md;
                    margin-bottom: @padding-sm / 2;
                }
            }
        }
    }
}
</style>
